import { createSettingsContextProvider } from "@faire/web/common/settings/hooks/createSettingsContextProvider";
var _createSettingsContex = createSettingsContextProvider(),
  useSetting = _createSettingsContex.useSetting,
  SettingsContextProvider = _createSettingsContex.SettingsContextProvider;
export { useSetting, SettingsContextProvider };